<div id="recover-password" class="app-entry">
    <div class="row">
        <div class="col-md-7 form-wrapper">
            <p class="text-center logo-wrapper"><img src="/assets/nurturebossFULLcolor.png" /></p>
            <div class="col-md-6 offset-md-3">
                <h2>Lost your password?<br />Enter your details to recover.</h2>
                <span class="forgot-psw-helper-span">Enter your details to proceed further</span>
                <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label for="email">Email</label>
                        <div class="input-group mb-3">
                            <input type="text" placeholder="Start typing..." formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                            <div class="input-group-append">
                              <span class="input-group-text"><i class="far fa-envelope-open"></i></span>
                            </div>
                        </div>
                        <div *ngIf="submitted && f.email.errors" class="form-errors">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                        </div>
                    </div>
                    <div class="row accessories-bar">
                        <div class="col-sm-6">
                            <button [disabled]="loading" class="pull-left button button-dark">
                                Recover
                            </button>
                        </div>
                        <div class="col-sm-6">
                            <!-- <button [disabled]="loading" class="pull-right button button-light">
                                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                Sign Up
                            </button> -->
                        </div>
                    </div>
                    <div *ngIf="error" class="alert alert-danger">{{error}}</div>
                </form>
            </div>
        </div>
        <div class="col-md-5 login-bg"></div>
    </div>
</div>